import { render, staticRenderFns } from "./FiltersSidebar.vue?vue&type=template&id=260553cd&scoped=true"
import script from "./FiltersSidebar.vue?vue&type=script&lang=js"
export * from "./FiltersSidebar.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./FiltersSidebar.vue?vue&type=style&index=0&id=260553cd&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "260553cd",
  "77ce1752"
  
)

export default component.exports